"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  /**
   * @ngdoc object
   * @name login.controller:LoginCtrl
   *
   * @description
   *
   */

  LoginCtrl.$inject = ["$rootScope", "$scope", "AuthService", "UsersService"];
  angular.module("login").controller("LoginCtrl", LoginCtrl);

  function LoginCtrl($rootScope, $scope, AuthService, UsersService) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "LoginCtrl";

    $("#loading").remove();

    vm.load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.load();

    vm.checkYourEmail = false;

    vm.login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("call login", vm.email);

              AuthService.login(vm.email, vm.password, vm.code).then(function (response) {
                AuthService.whoami();
              }).catch(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(err) {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          console.log("login err", err);

                          if (!(err.message === "2FA requis")) {
                            _context2.next = 6;
                            break;
                          }

                          console.log("2FA requis");
                          vm.with2FA = true;

                          $scope.$apply();
                          return _context2.abrupt("return");

                        case 6:

                          $rootScope.$user = null;

                          $rootScope.$bus.publish({
                            channel: "login",
                            topic: "failed",
                            data: {}
                          });

                          _context2.next = 10;
                          return swal("", "Identification impossible : rééssayer ou contacter le support.", "error");

                        case 10:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    vm.getLink = function () {
      Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

      try {
        UsersService.customGet("sendLink/" + vm.email).then(function (response) {
          if (response.success === true) {
            Notiflix.Notify.success("L'envoi de l'email a réussi");
            vm.checkYourEmail = true;
          }
          Notiflix.Loading.remove();
        }).catch(function (error) {
          Notiflix.Notify.failure("L'envoi de l'email a échoué ou l'utilisateur n'existe pas");
          Notiflix.Loading.remove();
        });
      } catch (error) {
        Notiflix.Notify.failure("L'envoi de l'email a échoué ou l'utilisateur n'existe pas");
        Notiflix.Loading.remove();
      }
    };
  }
})();